<template>
  <div class="lesson">
    <div class="bannerBox">
      <div class="desc">为您精挑细选每一门课程</div>
      <!-- <img class="banner" src="https://web-data.zmlearn.com/image/7TgZMZgdshx6wiroB4Lx3V/lesson_list_banner.png" alt="" /> -->
    </div>
    <section class="lessonWrapper">
      <!-- 户外课程 -->
      <p class="title">素质课程（户外）</p>
      <section class="out">
        <div class="list">
          <img
            class="img"
            v-for="(item, index) in outList"
            :key="index"
            :src="item.posterSrc"
            @click="goLessonDetail(item)"
            alt=""
          />
        </div>
      </section>
      <!-- 室内课程 -->
      <p class="title">素质课程（室内）</p>
      <section class="inner">
        <div class="list">
          <img
            class="img"
            v-for="(item, index) in innerList"
            :key="index"
            :src="item.posterSrc"
            @click="goLessonDetail(item)"
            alt=""
          />
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import { LESSONS_IDX1_DATA, LESSONS_IDX2_DATA } from '../../utils/LingXunData'
export default {
  name: 'Lesson',
  data () {
    return {
      outList: LESSONS_IDX1_DATA,
      innerList: LESSONS_IDX2_DATA
    }
  },
  methods: {
    goLessonDetail (item) {
      localStorage.setItem('LESSON_DETAIL', JSON.stringify(item))
      this.$router.push({
        path: `/lessonDetail/${item.id}`
      })
    }
  }
}
</script>
<style scoped lang="scss">
  .lesson{
    height: auto;
    min-height: 768px;
    width: 100%;
    .bannerBox{
      height: 400px;
      background-image: url('https://web-data.zmlearn.com/image/7TgZMZgdshx6wiroB4Lx3V/lesson_list_banner.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      position: relative;
      .desc{
        height: 60px;
        width: 100%;
        font-size: 60px;
        font-weight: 600;
        color: #fff;
        line-height: 60px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
      .banner{
        width: auto;
        max-width: 100%;
        height: 400px;
      }
    }
    .title{
      height: 30px;
      font-size: 24px;
      font-weight: 600;
      color: #333;
      text-align: left;
      line-height: 30px;
      margin-bottom: 30px;
    }
    .lessonWrapper{
      height: auto;
      min-height: 768px;
      width: 1192px;
      margin: 0 auto;
      .out, .inner{
        height: auto;
        width: 100%;
        overflow: hidden;
        .list{
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: center;
          justify-content: flex-start;
          .img{
            width: 274px;
            height: 259px;
            margin: 0 32px 32px 0;
            cursor: pointer;
            &:nth-of-type(4n){
              margin-right: 0;
            }
          }
        }
      }
    }
  }
</style>
